(function () {
  const debounce = (callback, wait) => {
    let timer = null;
    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => callback(...args), wait);
    };
  };

  window.RotaTheme?.register('predictive-search', {
    init(root) {
      const form = root.matches('form') ? root : root.querySelector('form');
      const input = root.querySelector('input[type="search"]');
      const panel = root.querySelector('[data-predictive-search-panel]');
      const clearButton = root.querySelector('[data-predictive-search-clear]');
      const enabled = root.dataset.predictiveEnabled === 'true';
      const endpoint = root.dataset.predictiveSearchUrl;
      let controller = null;

      if (!form || !input || !panel) return null;

      const close = () => {
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      };

      const open = () => {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      const setLoading = () => {
        panel.innerHTML = `<p class="rm-predictive-search__status">${root.dataset.loadingText || 'Loading'}</p>`;
        open();
      };

      const updateClear = () => {
        if (clearButton) clearButton.hidden = input.value.trim().length === 0;
      };

      const render = (html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const content = parsed.querySelector('[data-predictive-search-content]');
        panel.innerHTML = content ? content.outerHTML : html;
        open();
      };

      const search = debounce(async () => {
        const term = input.value.trim();
        updateClear();
        if (!enabled || !endpoint || term.length < 2) {
          close();
          return;
        }

        controller?.abort();
        controller = new AbortController();
        setLoading();

        try {
          const params = new URLSearchParams({
            q: term,
            section_id: 'predictive-search',
            'resources[type]': 'query,product,collection,article,page',
          });
          const response = await fetch(`${endpoint}?${params.toString()}`, {
            signal: controller.signal,
            headers: { Accept: 'text/html' },
          });
          if (!response.ok) throw new Error(response.statusText);
          render(await response.text());
        } catch (error) {
          if (error.name === 'AbortError') return;
          panel.innerHTML = `<p class="rm-predictive-search__empty">${root.dataset.errorText || 'Search is unavailable right now.'}</p>`;
          open();
        }
      }, 180);

      const handleKeydown = (event) => {
        if (event.key === 'Escape') {
          close();
          input.focus({ preventScroll: true });
        }
      };
      const handleDocumentPointer = (event) => {
        if (!root.contains(event.target)) close();
      };
      const handleClear = () => {
        input.value = '';
        updateClear();
        close();
        input.focus({ preventScroll: true });
      };

      input.addEventListener('input', search);
      input.addEventListener('keydown', handleKeydown);
      document.addEventListener('pointerdown', handleDocumentPointer);
      clearButton?.addEventListener('click', handleClear);
      updateClear();

      return () => {
        controller?.abort();
        input.removeEventListener('input', search);
        input.removeEventListener('keydown', handleKeydown);
        document.removeEventListener('pointerdown', handleDocumentPointer);
        clearButton?.removeEventListener('click', handleClear);
      };
    },
  });
})();
